<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="filterRequests"
            item-key="id"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            :items-per-page="15"
            fixed-header
            :item-class="getRowClass"
            :footer-props="{
                itemsPerPageOptions: [15, 30, 50, 100],
                itemsPerPageText: 'Invoices Per Page',
            }"
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="align-center py-4 mx-0"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="6" class="d-flex align-center">
                        <h3 class="text-h6 font-weight-bold text-primary">
                            WITHOUT PO
                        </h3>
                    </v-col>
                    <v-col
                        cols="6"
                        class="d-flex justify-end align-center pr-sm-8 pr-md-2 pr-lg-3 pr-xl-3"
                    >
                        <v-btn
                            rounded
                            color="primary"
                            @click="createNewPurchase"
                            v-if="editPurchasingInvoicePermission"
                        >
                            <v-icon left>mdi-upload</v-icon>
                            Create Invoice
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.supplier`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="supplierToFilterDraft"
                    @input="scheduleFilterSync"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.file`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="fileToFilterDraft"
                    @input="scheduleFilterSync"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.dueDate`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="dueDateToFilterDraft"
                    @input="scheduleFilterSync"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.date`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="dateToFilterDraft"
                    @input="scheduleFilterSync"
                    dense
                    class="pt-2"
                />
            </template>

            <!--ITEMS-->
            <template v-slot:[`item.dueDate`]="{ item }">
                {{ item.dueDate || '' }}
            </template>
            <template v-slot:[`item.date`]="{ item }">
                {{ item.date || item.invoiceDate || '' }}
            </template>
            <template v-slot:[`item.file`]="{ item }">
                <div
                    v-if="
                        item.file &&
                            Array.isArray(item.file) &&
                            item.file.length > 0
                    "
                >
                    <div v-for="(file, index) in item.file" :key="index">
                        <a
                            href="#"
                            @click.prevent="openInvoice(item, file)"
                            class="my-0 text-decoration-none"
                            :style="{
                                'font-size': '11px',
                                color: invoiceMarked(item)
                                    ? '#f44336'
                                    : '#2b81d6',
                                'text-decoration': 'underline',
                                cursor: 'pointer',
                            }"
                        >
                            {{ item.consecutive ? item.consecutive : file }}
                        </a>
                    </div>
                </div>
                <div v-else-if="item.file && !Array.isArray(item.file)">
                    <a
                        href="#"
                        @click.prevent="openInvoice(item)"
                        class="my-0 text-decoration-none"
                        :style="{
                            'font-size': '11px',
                            color: invoiceMarked(item) ? '#f44336' : '#2b81d6',
                            'text-decoration': 'underline',
                            cursor: 'pointer',
                        }"
                    >
                        {{ item.consecutive ? item.consecutive : item.file }}
                    </a>
                </div>
                <div v-else>
                    <p
                        class="my-0"
                        :style="{
                            color: invoiceMarked(item) ? '#f44336' : 'inherit',
                        }"
                    >
                        No file
                    </p>
                </div>
            </template>
            <template v-slot:[`item.notes`]="{ item }">
                <div class="d-flex align-center justify-center">
                    <v-btn
                        icon
                        small
                        :color="invoiceMarked(item) ? 'error' : 'primary'"
                        @click="openNotesModal(item)"
                    >
                        <v-icon small>mdi-note-text</v-icon>
                    </v-btn>
                    <span
                        class="ml-1"
                        style="font-size: 12px;"
                        :style="{
                            color: invoiceMarked(item) ? '#f44336' : 'inherit',
                        }"
                    >
                        {{ item.notesCount || 0 }}
                    </span>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex align-center justify-center">
                    <v-menu rounded offset-y>
                        <template v-slot:activator="{ attrs, on }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                                small
                                class="mx-1"
                                :disabled="!canShowInvoiceActions"
                            >
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item
                                v-if="item.file && canOpenInvoiceForm"
                                @click.stop="openEditInvoice(item)"
                                class="px-3"
                            >
                                <v-list-item-icon class="mr-3">
                                    <v-icon small>mdi-pencil</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="text-body-2">
                                        Edit Invoice
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                v-if="editPurchasingInvoicePermission"
                                @click.stop="openLinkInvoiceDialog(item)"
                                class="px-3"
                            >
                                <v-list-item-icon class="mr-3">
                                    <v-icon small>mdi-link</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="text-body-2">
                                        Link Invoice
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                v-if="
                                    item.file && editPurchasingInvoicePermission
                                "
                                @click.stop="openMarkForeignTradeDialog(item)"
                                class="px-3"
                            >
                                <v-list-item-icon class="mr-3">
                                    <v-icon small>mdi-earth</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="text-body-2">
                                        Mark as foreign trade
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                                v-if="deleteAccountingInvoicePermission"
                                @click.stop="deleteInvoice(item)"
                                class="px-3"
                            >
                                <v-list-item-icon class="mr-3">
                                    <v-icon small color="error"
                                        >mdi-delete</v-icon
                                    >
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="text-body-2">
                                        Delete Invoice
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>
        </v-data-table>
        <!--ALERT MESSAGES-->
        <v-alert
            v-if="activateAlert"
            type="success"
            color="primary"
            :style="{ position: 'absolute', right: '0px', bottom: '0px' }"
        >
            <v-row no-gutters>
                <v-col cols="11">
                    <p class="my-0">{{ alertMessage }}</p>
                </v-col>
                <v-col cols="1">
                    <v-btn
                        small
                        icon
                        class="mt-n1"
                        @click="activateAlert = false"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <!--Create New Purchase Modal-->
        <v-dialog v-model="createDialog" max-width="800px" persistent>
            <CreateNoOrderInvoice
                v-if="createDialog"
                :companyId="companyId"
                @closeDialog="closeCreateDialog"
                @created="handleInvoiceCreated"
            />
        </v-dialog>

        <!-- Edit Invoice Dialog -->
        <v-dialog v-model="editInvoiceDialog" max-width="800px" persistent>
            <EditNoOrderInvoice
                v-if="editInvoiceDialog"
                :invoice="selectedInvoice"
                :purchase="invoicePurchase"
                :can-edit-invoice="editPurchasingInvoicePermission"
                :can-reject-invoice="rejectAccountingInvoicePermission"
                :can-mark-credit-note="markInvoiceAsCreditNotePermission"
                @closeDialog="closeEditInvoiceDialog"
                @invoiceUpdated="handleInvoiceUpdated"
            />
        </v-dialog>

        <!--Link Invoice Dialog-->
        <LinkInvoice
            v-if="linkInvoiceDialog"
            :open="linkInvoiceDialog"
            :noOrderItem="selectedNoOrderItem || {}"
            :availablePurchases="availablePurchases"
            :companyId="companyId"
            :requests="requests"
            @closeDialog="closeLinkInvoiceDialog"
        />

        <!--Notes Modal-->
        <v-dialog v-model="notesDialog" max-width="600px" persistent>
            <v-card>
                <v-card-title class="headline">
                    <span>Notes - {{ selectedItem?.supplier }}</span>
                </v-card-title>

                <v-card-text>
                    <!-- Display existing notes -->
                    <div v-if="selectedItemNotes.length > 0" class="mb-4">
                        <h4>Existing Notes:</h4>
                        <v-card
                            v-for="(note, index) in selectedItemNotes"
                            :key="index"
                            class="mb-2 pa-3"
                            outlined
                        >
                            <div
                                class="d-flex justify-space-between align-start"
                            >
                                <div class="flex-grow-1">
                                    <div class="mb-1" v-html="note.note"></div>
                                    <small class="text--secondary">
                                        By: {{ note.username }} on
                                        {{ formatNoteDate(note.date) }}
                                    </small>
                                </div>
                            </div>
                        </v-card>
                    </div>

                    <!-- Add new note -->
                    <div>
                        <h4>Add New Note:</h4>
                        <vue-editor
                            v-if="notesDialog"
                            :editor-options="editorOptions"
                            v-model="newNote"
                            :disabled="addingNote"
                        />
                    </div>
                </v-card-text>

                <v-card-actions class="px-6">
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        text
                        @click="closeNotesModal"
                        :disabled="addingNote"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        small
                        rounded
                        color="primary"
                        @click="addNote"
                        :loading="addingNote"
                        :disabled="isNoteEmpty || addingNote"
                    >
                        Add Note
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="markForeignTradeDialog" max-width="500px" persistent>
            <v-card>
                <v-card-title class="headline">
                    <span>Mark as foreign trade</span>
                </v-card-title>
                <v-card-text>
                    <p class="mb-0">
                        This invoice will be sent to the Foreign Trade tab.
                    </p>
                </v-card-text>
                <v-card-actions class="px-6">
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        text
                        @click="closeMarkForeignTradeDialog"
                        :disabled="loading"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        small
                        rounded
                        color="primary"
                        @click="confirmMarkAsForeignTrade"
                        :loading="loading"
                        :disabled="loading"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteInvoiceDialog" max-width="500px" persistent>
            <v-card>
                <v-card-title class="headline">
                    <span>Delete Invoice</span>
                </v-card-title>

                <v-card-text>
                    <p>
                        Are you sure you want to delete this no order purchase
                    </p>
                </v-card-text>

                <v-card-actions class="px-6">
                    <v-spacer></v-spacer>
                    <v-btn
                        small
                        text
                        @click="closeDeleteInvoiceDialog"
                        :disabled="deletingInvoice"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        small
                        rounded
                        color="error"
                        @click="confirmDeleteInvoice"
                        :loading="deletingInvoice"
                        :disabled="deletingInvoice"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CreateNoOrderInvoice from '@/components/accountant/CreateNoOrderInvoice.vue'
import EditNoOrderInvoice from '@/components/accountant/EditNoOrderInvoice.vue'
import LinkInvoice from '@/components/accountant/LinkInvoice.vue'
import { firestore, storage, timestamp } from '@/services/firebase'
import moment from 'moment'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import API from '@/services/api'
import { openFile } from '@/services/storage/openFile.js'
import _ from 'lodash'

const MIN_CREATED_ON = '2026-01-01'

export default {
    name: 'AccountantNoRequisitions',

    components: {
        VueEditor: () =>
            import('vue2-editor').then(
                module => module.VueEditor || module.default
            ),
        CreateNoOrderInvoice,
        EditNoOrderInvoice,
        LinkInvoice,
    },
    data: () => ({
        activateAlert: false,
        alertMessage: '',
        loading: false,
        requests: [],
        supplierToFilter: undefined,
        fileToFilter: undefined,
        dueDateToFilter: undefined,
        dateToFilter: undefined,
        // Draft filter fields (debounced -> *ToFilter)
        supplierToFilterDraft: '',
        fileToFilterDraft: '',
        dueDateToFilterDraft: '',
        dateToFilterDraft: '',
        filterSyncTimeoutId: null,
        filterSyncDelayMs: 200,
        baseHeaders: [
            {
                text: 'SUPPLIER',
                value: 'supplier',
                sortable: false,
                align: 'center',
            },
            {
                text: 'TOTAL PRICE',
                value: 'totalPrice',
                sortable: false,
                align: 'center',
                width: '108px',
            },
            {
                text: 'DATE',
                value: 'date',
                sortable: true,
                width: '120px',
                align: 'center',
            },
            {
                text: 'DUE DATE',
                value: 'dueDate',
                sortable: true,
                width: '138px',
                align: 'center',
            },
            {
                text: 'FILE',
                value: 'file',
                sortable: false,
                align: 'center',
            },
            {
                text: 'NOTES',
                value: 'notes',
                sortable: false,
                align: 'center',
                width: '100px',
            },
        ],
        actionsHeader: {
            text: 'ACTIONS',
            value: 'actions',
            sortable: false,
            align: 'center',
            width: '150px',
        },

        companyId: JSON.parse(localStorage.getItem('company')),
        listener: null,
        resourceId: undefined,
        checkAccountantPurchasesPermission: undefined,
        editPurchasingInvoicePermission: undefined,
        rejectAccountingInvoicePermission: false,
        markInvoiceAsCreditNotePermission: false,
        deleteAccountingInvoicePermission: undefined,
        editInvoiceDialog: false,
        selectedInvoice: null,
        invoicePurchase: null,
        createDialog: false,
        notesDialog: false,
        selectedItem: null,
        selectedItemNotes: [],
        newNote: '',
        addingNote: false,
        currentUser: null,
        linkInvoiceDialog: false,
        selectedNoOrderItem: null,
        purchasesRequests: [],
        purchasesRequestsLoaded: false,
        deleteInvoiceDialog: false,
        purchaseToDeleteInvoice: null,
        deletingInvoice: false,
        markForeignTradeDialog: false,
        invoiceToMarkForeignTrade: null,
        editorOptions: {
            theme: 'snow',
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ list: 'bullet' }],
                    [{ list: 'ordered' }],
                    [{ color: [] }],
                    ['clean'],
                ],
            },
        },
    }),
    computed: {
        ...mapState(['notificationResource']),
        headers() {
            const headers = [...this.baseHeaders]
            if (this.canShowInvoiceActions) {
                headers.push(this.actionsHeader)
            }
            return headers
        },
        canOpenInvoiceForm() {
            return !!(
                this.editPurchasingInvoicePermission ||
                this.rejectAccountingInvoicePermission ||
                this.markInvoiceAsCreditNotePermission
            )
        },
        canShowInvoiceActions() {
            return !!(
                this.canOpenInvoiceForm ||
                this.deleteAccountingInvoicePermission
            )
        },
        filterRequests() {
            let conditions = []

            if (this.supplierToFilter) {
                const supplierFilter = this.supplierToFilter.toLowerCase()
                conditions.push(
                    item =>
                        item.supplier &&
                        item.supplier.toLowerCase().includes(supplierFilter)
                )
            }

            if (this.fileToFilter) {
                const filterText = this.fileToFilter.toLowerCase()
                conditions.push(item => {
                    if (!item.file) return false

                    const consecutiveMatches =
                        item.consecutive &&
                        item.consecutive.toLowerCase().includes(filterText)

                    if (Array.isArray(item.file)) {
                        return (
                            item.file.some(
                                file =>
                                    file &&
                                    file.toLowerCase().includes(filterText)
                            ) || consecutiveMatches
                        )
                    }

                    const fileMatches = item.file
                        .toLowerCase()
                        .includes(filterText)
                    return fileMatches || consecutiveMatches
                })
            }

            if (this.dueDateToFilter) {
                const dueDateFilter = this.dueDateToFilter.toLowerCase()
                conditions.push(
                    item =>
                        item.dueDate &&
                        item.dueDate.toLowerCase().includes(dueDateFilter)
                )
            }

            if (this.dateToFilter) {
                const dateFilter = this.dateToFilter.toLowerCase()
                conditions.push(
                    item =>
                        item.invoiceDate &&
                        item.invoiceDate.toLowerCase().includes(dateFilter)
                )
            }

            const filteredItems =
                conditions.length > 0
                    ? this.requests.filter(item =>
                          conditions.every(condition => condition(item))
                      )
                    : this.requests

            return filteredItems.slice().sort((a, b) => {
                const aHasFile = !!(a.file && a.file.length)
                const bHasFile = !!(b.file && b.file.length)

                if (aHasFile !== bHasFile) {
                    return aHasFile ? -1 : 1
                }

                if (a.dueDate && b.dueDate) {
                    if (a.dueDate === b.dueDate) return 0
                    return a.dueDate > b.dueDate ? -1 : 1
                }
                if (a.dueDate && !b.dueDate) return -1
                if (!a.dueDate && b.dueDate) return 1
                return 0
            })
        },
        isNoteEmpty() {
            if (!this.newNote) return true
            // Strip HTML tags and check if content is empty
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = this.newNote
            return tempDiv.textContent.trim().length === 0
        },
        availablePurchases() {
            return this.purchasesRequests.map(request => {
                // Get all unique order numbers
                const orderNumbers = new Set()
                if (request.items && request.items.length > 0) {
                    request.items.forEach(item => {
                        if (
                            item.purchaseOrder &&
                            item.purchaseOrder.orderNumber
                        ) {
                            orderNumbers.add(item.purchaseOrder.orderNumber)
                        }
                    })
                }

                return {
                    id: request.id,
                    requestNumber: request.number,
                    requestStatus: request.status,
                    project: request.project,
                    orderNumbers: Array.from(orderNumbers),
                    displayText: `ID: ${request.number} / ORDERS: ${
                        orderNumbers.size > 0
                            ? Array.from(orderNumbers).join(', ')
                            : 'N/A'
                    }`,
                }
            })
        },
    },
    watch: {
        notificationResource: function(resource) {
            if (resource) {
                this.resourceId = resource
                this.openResource()
                this.setNotificationResource(undefined)
            }
        },
    },
    async mounted() {
        try {
            this.resourceId = this.$route.query.resourceId
            const {
                data: { user },
            } = await API.getMyInfo()

            this.currentUser = user
            this.editPurchasingInvoicePermission = this.currentUser.permissions.includes(
                'editPurchasingInvoice'
            )
            this.rejectAccountingInvoicePermission = this.currentUser.permissions.includes(
                'rejectAccountingInvoice'
            )
            this.markInvoiceAsCreditNotePermission = this.currentUser.permissions.includes(
                'markInvoiceAsCreditNote'
            )
            this.deleteAccountingInvoicePermission = this.currentUser.permissions.includes(
                'deleteAccountingInvoice'
            )

            // Check permission before loading data
            if (!this.currentUser.permissions.includes('withOutPoAccounting')) {
                this.loading = false
                return
            }

            this.loading = true

            await this.loadInitialData()
            this.setupRealtimeListener()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        if (this.listener) {
            this.listener()
            this.listener = null
        }
        if (this.filterSyncTimeoutId) {
            clearTimeout(this.filterSyncTimeoutId)
            this.filterSyncTimeoutId = null
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        ...mapActions(['setNotificationResource']),
        ...mapGetters(['getNotificationResource']),
        scheduleFilterSync() {
            if (this.filterSyncTimeoutId) {
                clearTimeout(this.filterSyncTimeoutId)
            }
            this.filterSyncTimeoutId = setTimeout(() => {
                this.applyFilterDrafts()
            }, this.filterSyncDelayMs)
        },
        applyFilterDrafts() {
            const normalize = value => {
                if (value === null || value === undefined) return undefined
                const strValue = String(value).trim()
                return strValue === '' ? undefined : strValue
            }

            this.supplierToFilter = normalize(this.supplierToFilterDraft)
            this.fileToFilter = normalize(this.fileToFilterDraft)
            this.dueDateToFilter = normalize(this.dueDateToFilterDraft)
            this.dateToFilter = normalize(this.dateToFilterDraft)
        },

        async loadInitialData() {
            try {
                const purchases = await API.getNoOrderPurchases({
                    excludeForeignTrade: true,
                    lite: true,
                    minCreatedOn: MIN_CREATED_ON,
                })

                this.requests = (purchases || []).map(request =>
                    this.normalizeNoOrderPurchase(request)
                )
            } catch (error) {
                this.requests = []
                this.setErrorItems({
                    source: this.$options.name,
                    message: `Failed to load initial data: ${error.message}`,
                })
            }
        },

        async setupRealtimeListener() {
            try {
                const minCreatedOn = timestamp.fromDate(
                    new Date(`${MIN_CREATED_ON}T00:00:00.000Z`)
                )
                const NoOrderPurchasesQuery = firestore
                    .collection('companies')
                    .doc(this.companyId)
                    .collection('noOrderPurchases')
                    .where('createdOn', '>=', minCreatedOn)

                let isInitialSnapshot = true
                this.listener = NoOrderPurchasesQuery.onSnapshot(
                    docSnapshot => {
                        if (isInitialSnapshot) {
                            isInitialSnapshot = false
                            const existingIds = new Set(
                                this.requests.map(request => request.id)
                            )
                            const missing = []
                            docSnapshot.docChanges().forEach(change => {
                                if (change.type !== 'added') return
                                if (existingIds.has(change.doc.id)) return
                                const data = {
                                    id: change.doc.id,
                                    ...change.doc.data(),
                                }
                                if (!this.isVisibleNoOrderPurchase(data)) return
                                missing.push(
                                    this.normalizeNoOrderPurchase(data)
                                )
                            })
                            if (missing.length > 0) {
                                this.requests = this.requests.concat(missing)
                            }
                            return
                        }

                        docSnapshot.docChanges().forEach(change => {
                            this.applyRealtimeChange(change)
                        })
                    },
                    error => {
                        console.error('Real-time listener error:', error)
                        this.setErrorItems({
                            source: this.$options.name,
                            message: `Real-time updates failed: ${error.message}`,
                        })
                    }
                )
            } catch (error) {
                console.error('Error setting up real-time listener:', error)
                this.setErrorItems({
                    source: this.$options.name,
                    message: `Failed to set up real-time updates: ${error.message}`,
                })
            }
        },
        applyRealtimeChange(change) {
            const data = {
                id: change.doc.id,
                ...change.doc.data(),
            }
            if (!this.isVisibleNoOrderPurchase(data)) {
                if (change.type === 'added') return
                const index = this.requests.findIndex(
                    current => current.id === data.id
                )
                if (index >= 0) {
                    this.requests.splice(index, 1)
                }
                return
            }
            const request = this.normalizeNoOrderPurchase(data)

            if (change.type === 'added') {
                const exists = this.requests.some(
                    current => current.id === request.id
                )
                if (!exists) {
                    this.requests.push(request)
                }
                return
            }

            const index = this.requests.findIndex(
                current => current.id === request.id
            )
            if (change.type === 'modified' && index >= 0) {
                this.requests.splice(index, 1, request)
            } else if (change.type === 'removed' && index >= 0) {
                this.requests.splice(index, 1)
            }
        },
        isVisibleNoOrderPurchase(data) {
            if (!data || data.foreignTrade === true) return false
            const createdOn = this.formatMaybeDate(data.createdOn)
            return createdOn >= MIN_CREATED_ON
        },
        normalizeNoOrderPurchase(request) {
            const dueDate = this.formatMaybeDate(request.dueDate)
            const invoiceDate = this.formatMaybeDate(request.invoiceDate)
            const notes = request.notes || []

            return {
                id: request.id,
                supplier: request.supplier,
                consecutive: request.consecutive,
                totalPrice: request.totalPrice,
                dueDate,
                file: request.file || [],
                invoiceDate,
                date: invoiceDate || 'not found',
                notes,
                notesCount: notes.length,
                rejected: request.rejected || false,
                creditNote: !!request.creditNote,
                creditNotePreviousConsecutive:
                    request.creditNotePreviousConsecutive ?? null,
                invoiceAttachments: request.invoiceAttachments || [],
            }
        },
        formatMaybeDate(value) {
            if (value == null || value === '') return ''
            if (typeof value === 'string') {
                if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
                    return value.slice(0, 10)
                }
                if (value.trim().startsWith('{')) {
                    try {
                        return this.formatMaybeDate(JSON.parse(value))
                    } catch (error) {
                        return value
                    }
                }
                const parsed = moment(value)
                return parsed.isValid() ? parsed.format('YYYY-MM-DD') : value
            }
            if (typeof value.toDate === 'function') {
                return moment(value.toDate()).format('YYYY-MM-DD')
            }
            const seconds = value.seconds ?? value._seconds
            if (seconds != null && seconds !== '') {
                const numericSeconds = Number(seconds)
                if (!Number.isNaN(numericSeconds)) {
                    return this.formatDate(numericSeconds)
                }
            }
            if (value instanceof Date && !Number.isNaN(value.getTime())) {
                return moment(value).format('YYYY-MM-DD')
            }
            return ''
        },
        formatNumber(number) {
            return new Intl.NumberFormat('de-DE').format(
                Math.ceil(number != undefined ? number : 0)
            )
        },
        formatDate(seconds) {
            return moment.unix(seconds).format('YYYY-MM-DD')
        },
        async openInvoice(item, fileName = null) {
            try {
                const fileToOpen = fileName || item.file

                // Helper function to check if file exists and open it
                const tryOpenFile = async filePath => {
                    try {
                        const storageRef = storage().ref(filePath)
                        const fileRef = storageRef.child(fileToOpen)
                        // Check if file exists using getMetadata
                        await fileRef.getMetadata()
                        // File exists, open it
                        await openFile(fileToOpen, filePath)
                        return true
                    } catch (error) {
                        // File doesn't exist or error accessing it
                        return false
                    }
                }

                // Try first path: base path
                const basePath = `${this.companyId}/noOrderPurchases/${item.id}`
                const openedInBase = await tryOpenFile(basePath)

                if (openedInBase) {
                    // Successfully opened in base path, stop execution
                    return
                }

                // File doesn't exist in base path, try files subfolder
                const filesPath = `${this.companyId}/noOrderPurchases/${item.id}/files`
                const openedInFiles = await tryOpenFile(filesPath)

                if (openedInFiles) {
                    // Successfully opened in files subfolder, stop execution
                    return
                }
                // File doesn't exist in either path
                throw new Error(`File "${fileToOpen}" not found`)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: `Error opening file: ${error.message}`,
                })
            }
        },
        createNewPurchase() {
            this.createDialog = true
        },
        closeCreateDialog() {
            this.createDialog = false
        },
        handleInvoiceCreated() {
            this.alertMessage = 'Purchase created successfully'
            this.activateAlert = true
        },
        openNotesModal(item) {
            this.selectedItem = item
            this.selectedItemNotes = item.notes || []
            this.newNote = ''
            this.notesDialog = true
        },
        closeNotesModal() {
            this.notesDialog = false
            this.selectedItem = null
            this.selectedItemNotes = []
            this.newNote = ''
        },
        async addNote() {
            if (!this.newNote.trim()) return

            try {
                this.addingNote = true

                const noteData = {
                    note: this.newNote.trim(),
                    date: new Date().toISOString(),
                    userId: this.currentUser?.id || 'unknown',
                    username: this.currentUser?.name || 'Unknown User',
                }

                await API.addNoOrderPurchaseNote({
                    companyId: this.companyId,
                    documentId: this.selectedItem.id,
                    note: noteData,
                })

                this.selectedItemNotes.push(noteData)
                this.selectedItem.notes = this.selectedItemNotes
                this.selectedItem.notesCount = this.selectedItemNotes.length

                const requestIndex = this.requests.findIndex(
                    r => r.id === this.selectedItem.id
                )
                if (requestIndex >= 0) {
                    this.requests[requestIndex].notes = this.selectedItemNotes
                }

                this.newNote = ''

                this.alertMessage = 'Note added successfully'
                this.activateAlert = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: `Error adding note: ${error.message}`,
                })
            } finally {
                this.addingNote = false
            }
        },
        formatNoteDate(dateString) {
            return moment(dateString).format('YYYY-MM-DD HH:mm')
        },
        invoiceMarked(item) {
            return !!(item && (item.rejected || item.creditNote))
        },
        getRowClass(item) {
            if (item.rejected) return 'rejected-row'
            if (item.creditNote) return 'credit-note-row'
            return ''
        },
        openEditInvoice(item) {
            let fileName = null
            if (Array.isArray(item.file) && item.file.length > 0) {
                fileName = item.file[0]
            } else if (item.file && !Array.isArray(item.file)) {
                fileName = item.file
            }

            const invoice = {
                fileName: fileName,
                invoiceDate: item.invoiceDate || null,
                dueDate: item.dueDate || null,
                consecutive: item.consecutive || null,
                rejected: item.rejected || false,
                creditNote: !!item.creditNote,
                creditNotePreviousConsecutive:
                    item.creditNotePreviousConsecutive ?? null,
                invoiceAttachments: item.invoiceAttachments || [],
            }

            let allFiles = []

            // file can be array or single string
            if (item.file) {
                if (Array.isArray(item.file) && item.file.length > 0) {
                    allFiles = [...item.file]
                } else if (
                    typeof item.file === 'string' &&
                    item.file.trim() !== ''
                ) {
                    allFiles = [item.file]
                }
            }

            const purchase = {
                id: item.id,
                purchaseInvoices: [invoice],
                file: allFiles,
            }

            this.selectedInvoice = invoice
            this.invoicePurchase = purchase
            this.editInvoiceDialog = true
        },
        closeEditInvoiceDialog() {
            this.editInvoiceDialog = false
            this.selectedInvoice = null
            this.invoicePurchase = null
        },
        handleInvoiceUpdated(update) {
            const index = this.requests.findIndex(
                r => r.id === update.documentId
            )
            if (index < 0) return

            this.$set(this.requests, index, {
                ...this.requests[index],
                dueDate: update.dueDate,
                invoiceDate: update.invoiceDate,
                date: update.invoiceDate || 'not found',
                consecutive: update.consecutive,
                creditNote: !!update.creditNote,
                file: update.file,
                invoiceAttachments: update.invoiceAttachments,
            })
        },
        async loadAccountantPurchases() {
            const purchases = await API.getAccountantPurchases()
            this.purchasesRequests = purchases || []
        },
        async openLinkInvoiceDialog(item) {
            try {
                if (!this.purchasesRequestsLoaded) {
                    await this.loadAccountantPurchases()
                    this.purchasesRequestsLoaded = true
                }
                this.selectedNoOrderItem = _.cloneDeep(item)
                this.linkInvoiceDialog = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        closeLinkInvoiceDialog() {
            this.linkInvoiceDialog = false
            this.selectedNoOrderItem = null
        },
        openMarkForeignTradeDialog(item) {
            this.invoiceToMarkForeignTrade = _.cloneDeep(item)
            this.markForeignTradeDialog = true
        },
        closeMarkForeignTradeDialog() {
            this.markForeignTradeDialog = false
            this.invoiceToMarkForeignTrade = null
        },
        async confirmMarkAsForeignTrade() {
            try {
                this.loading = true
                await API.updateNoOrderPurchase({
                    documentId: this.invoiceToMarkForeignTrade.id,
                    foreignTrade: true,
                })
                this.closeMarkForeignTradeDialog()
                this.alertMessage = 'Invoice sent to the Foreign Trade tab'
                this.activateAlert = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message:
                        error.message ||
                        'Error marking invoice as foreign trade',
                })
            } finally {
                this.loading = false
            }
        },
        deleteInvoice(item) {
            this.purchaseToDeleteInvoice = item
            this.deleteInvoiceDialog = true
        },
        closeDeleteInvoiceDialog() {
            this.deleteInvoiceDialog = false
            this.purchaseToDeleteInvoice = null
        },
        async confirmDeleteInvoice() {
            try {
                this.deletingInvoice = true
                await API.deleteNoOrderInvoice({
                    companyId: this.companyId,
                    noOrderId: this.purchaseToDeleteInvoice.id,
                })
                this.closeDeleteInvoiceDialog()
                this.alertMessage = 'No order purchase deleted successfully'
                this.activateAlert = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: `Error deleting no order purchase: ${error.message}`,
                })
            } finally {
                this.deletingInvoice = false
            }
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
    position: sticky;
    z-index: 1;
}
.v-input .v-label {
    font-size: 12px;
}
.v-data-table-header th {
    background-color: #eeeeee !important;
}
.v-data-table__wrapper {
    max-height: 65vh;
    overflow-y: auto;
}
.v-data-table__row {
    height: 80px;
}
.v-data-table__wrapper thead tr {
    position: sticky;
    top: 0;
    z-index: 10;
}

.v-menu__content {
    box-shadow: none !important;
}

.rejected-row {
    background-color: #ffebee !important;
}

.rejected-row td {
    color: #f44336 !important;
}

.credit-note-row td {
    color: #f44336 !important;
}
</style>
